import PageHeading from "component/ui/PageHeading";
import { Trash } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonModal from "component/ui/CommonModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteEvent,
  getAssignedMatches,
  getPostingList,
} from "store/slice/booking";
import { getSportsIcon } from "helper/appConstant";
import { CARD_TYPE, TYPES } from "helper/constant";
import FullPageLoader from "component/ui/fullPageLoader";
import venueIcon from "../../assets/venue.png";
import AvatarStack from "component/ui/AvtarStack";
import Button from "component/ui/Button";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import { clearVenueDetails, getVenueDetails } from "store/slice/profile";
import AssignedMatchDetailsDialog from "./assignedMatchDetails";
const EventBox = React.memo(({ event, configData, handleDetails }) => {
  return (
    <div className="border  border-gray-200 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-gray-100 to-gray-200 flex justify-between items-start p-4">
        <div className="flex gap-3 items-start flex-1">
          <div className="w-8 h-8 rounded-lg bg-orange-400 p-1.5 shadow-sm flex-shrink-0">
            <img src={venueIcon} className="w-full h-full object-contain " />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-base font-medium text-gray-800 line-clamp-1">
              {event?.cardType && CARD_TYPE[event?.cardType]}
            </p>
            {/* <p
              onClick={() => handleDetails(event?.cardId)}
              className="text-xs  border-b font-semibold border-highlight w-fit text-highlight cursor-pointer"
            >
              View Details
            </p> */}
          </div>
        </div>
      </div>

      <div className="p-4">
        <div className="flex gap-3 items-center w-full mb-3 ">
          {event?.profileImageUrl ? (
            <div
              className="md:w-10 md:h-10 w-5 rounded-full ring-2"
              style={{
                backgroundImage: `url("${event?.profileImageUrl}")`,
                backgroundSize: "cover",
              }}
            ></div>
          ) : (
            <div className="md:w-10 md:h-10 w-5 flex justify-center items-center font-semibold text-white rounded-full bg-highlight ring-2">
              {event?.name && event?.name?.charAt(0)?.toUpperCase()}
            </div>
          )}

          <p className="text-sm">{event?.name}</p>
        </div>
        {/* Content Section */}
        <div className="flex items-start justify-between w-full ">
          <div className="flex flex-col gap-1 flex-1">
            <div className="flex items-center gap-3 py-1">
              <div className="w-6 h-6 ">🧾</div>
              <p className="font-normal text-gray-800 text-sm">
                {event?.cardReferenceID}
              </p>
            </div>

            {/* Date */}
            <div className="flex items-center gap-3 text-sm text-gray-600">
              <span className="text-lg">📅</span>
              <span className="font-normal">{event?.startDate}</span>
            </div>
          </div>

          {/* Category Badge */}
          <div className="flex items-center flex-col justify-center p-3 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 w-36 shadow-sm ml-3">
            <div className="w-10 h-10 flex justify-center rounded-lg bg-white p-2 shadow-sm mb-2">
              {getSportsIcon(configData?.gamesDetails, event?.sportName)}
            </div>
            <p className="text-xs font-semibold text-gray-700 text-center line-clamp-2 leading-tight">
              {event?.sportName}
            </p>
          </div>
        </div>

        <div className="w-full ">
          <p>Assigned Users</p>
          <div className="flex items-center justify-between">
            <AvatarStack users={event?.joinPlayersData} maxVisible={5} />
            <Button onClick={() => handleDetails(event?.cardId)}>
              View Details
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});

const AssignMatch = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { assignedMatchListData } = useSelector((state) => state.booking);
  const { venueDetailsData } = useSelector((state) => state.profile);
  const { configData } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [searchQuery, setSearchQuery] = useState();
  const [showDialog, setShowDialog] = useState(false);
  useEffect(() => {
    setLoading(true);
    fetchAssignedMatchesList();
  }, []);
  // fetch my posting list
  const fetchAssignedMatchesList = (page, search) => {
    dispatch(
      getAssignedMatches(
        page ?? 1,
        200,
        search ? search : searchQuery ?? "",
        setLoading
      )
    );
  };
  const handleDetails = (id) => {
    setLoading(true);
    dispatch(getVenueDetails(id, setLoading, setShowDialog));
  };

  return (
    <>
      <div className="min-h-screen p-4 md:p-6">
        <div className="container mx-auto">
          <div className="flex items-center justify-between">
            <PageHeading title="Assign Matches" />
          </div>
          {loading && <FullPageLoader />}
          <div className="rounded-2xl md:shadow-2xl md:bg-white border border-gray-100 overflow-hidden w-full md:p-5">
            <div className="w-1/2">
              <SearchInput
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  fetchAssignedMatchesList(null, e.target.value);
                }}
                placeholder="Search by card id/sport"
                icon={FiSearch}
                className="rounded-full"
              />
            </div>
            {assignedMatchListData?.data?.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
                {assignedMatchListData?.data?.map((event) => (
                  <EventBox
                    event={event}
                    configData={configData}
                    navigate={navigate}
                    handleDetails={handleDetails}
                  />
                ))}
              </div>
            ) : (
              <div className="flex justify-center items-center h-40">
                No Posting Found
              </div>
            )}
          </div>
        </div>
      </div>
      {showDialog && (
        <AssignedMatchDetailsDialog
          open={showDialog}
          data={venueDetailsData}
          closeDialog={() => {
            setShowDialog(false);
            dispatch(clearVenueDetails());
          }}
        />
      )}
    </>
  );
};

export default AssignMatch;
